import { useContext } from 'react';
import { MyContext } from '../context';
import { can } from '../utils/permissions';

export function useCan(allowedRoles) {
	const { userProfile, activeStoreRole } = useContext(MyContext);
	const effectiveRole = userProfile?.role === 'PLATFORMADMIN' ? 'PLATFORMADMIN' : activeStoreRole;
	return can(effectiveRole, allowedRoles);
}
